import { ProfileForm } from '../organisms/profile/ProfileForm'
import { SideMenu } from '../organisms/profile/SideMenu'
import { StyledContainer } from './styles/Profile.style'

export const Profile = () => {
  return (
    <StyledContainer>
      <SideMenu />
      <ProfileForm />
    </StyledContainer>
  )
}
